export enum PlanEnum {
  Demo = 'Demo',
  S = 'S',
  M = 'M',
  L = 'L',
}

export function getContractLimit(plan: PlanEnum | string): number {
  switch (plan) {
    case PlanEnum.Demo:
      return 10;
    case PlanEnum.S:
      return 50;
    case PlanEnum.M:
      return 100;
    case PlanEnum.L:
      return Number.MAX_SAFE_INTEGER; // Ilimitado
    default:
      return 10; // Por defecto Demo
  }
}

export function getUserLimit(plan: PlanEnum | string): number {
  switch (plan) {
    case PlanEnum.Demo:
      return 2;
    case PlanEnum.S:
      return 2;
    case PlanEnum.M:
      return 5;
    case PlanEnum.L:
      return Number.MAX_SAFE_INTEGER; // Ilimitado
    default:
      return 2; // Por defecto Demo
  }
}




